<header class="admin-header">
  <div class="left">
    <h1>WILLPARRY(EMR STORE)</h1>
  </div>

  <div class="center">
    <span class="clock">{{ currentTime }}</span>
  </div>

  <div class="right">
    <span class="user">👤 {{ username }}</span>
    <button class="logout-btn" (click)="confirmLogout()" title="Logout">🚪</button>
  </div>
</header>
